export default __webpack_public_path__ + "static/bg-reporting-6108f775d912feb02f08fc92f2f6aa00.png";